import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const getFaqState = createSelector(
  (state: RootState) => state.faq,
  (state) => state,
);
